import { render, staticRenderFns } from "./addExercises.vue?vue&type=template&id=4ac9be6f&scoped=true"
import script from "./addExercises.vue?vue&type=script&lang=js"
export * from "./addExercises.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addExercises.vue?vue&type=style&index=1&id=4ac9be6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9be6f",
  null
  
)

export default component.exports